import { DEFAULT_PAGE_SIZE, METHOD_AXIOS } from '../utils/constant'
import { BaseApi } from './base.api'

export class UserApi extends BaseApi {
	constructor() {
		super('')
	}

	async getAllUser(page, pageSize = DEFAULT_PAGE_SIZE, filters = {}) {
		const params = new URLSearchParams({
			pageNum: String(page),
			pageSize: String(pageSize),
		})
		const email =
			typeof filters.authEmail === 'string' ? filters.authEmail.trim() : ''
		if (email) {
			params.set('authEmail', email)
		}
		const rs = await this.get(`api/user/all?${params.toString()}`)
		return rs
	}

	async getProfile() {
		const rs = await this.get('api/user/profile')
		return rs
	}

	async deleteUser(id) {
		const rs = await this.methodWithFormData(
			'api/user/profile',
			{ userID: id },
			METHOD_AXIOS.DELETE
		)
		return rs
	}
}
